import React, { useState } from 'react';
import { useBooking } from '../context/BookingContext';
import { ArrowLeftIcon, ArrowRightIcon, CalendarIcon, ClockIcon } from 'lucide-react';
export const DateTimeSelection = () => {
  const {
    booking,
    setBooking,
    nextStep,
    prevStep
  } = useBooking();
  const [selectedDate, setSelectedDate] = useState<Date | null>(booking.date || null);
  const [selectedTime, setSelectedTime] = useState<string | null>(booking.time || null);
  // Generate next 14 days for selection
  const generateDates = () => {
    const dates = [];
    const today = new Date();
    for (let i = 1; i <= 14; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }
    return dates;
  };
  const availableDates = generateDates();
  // Available time slots
  const timeSlots = ['9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM'];
  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  };
  const handleDateSelect = (date: Date) => {
    setSelectedDate(date);
    setSelectedTime(null); // Reset time when date changes
  };
  const handleTimeSelect = (time: string) => {
    setSelectedTime(time);
  };
  const handleContinue = () => {
    if (selectedDate && selectedTime) {
      setBooking(prev => ({
        ...prev,
        date: selectedDate,
        time: selectedTime
      }));
      nextStep();
    }
  };
  return <div data-id="element-119">
      <h3 className="text-xl font-medium text-amber-400 mb-2" data-id="element-120">
        Select Date & Time
      </h3>
      <p className="text-blue-100 mb-6" data-id="element-121">
        {booking.service?.name} with {booking.stylist?.name}
      </p>
      <div className="mb-6" data-id="element-122">
        <div className="flex items-center gap-2 mb-3" data-id="element-123">
          <CalendarIcon className="w-5 h-5 text-amber-400" data-id="element-124" />
          <h4 className="text-lg font-medium text-amber-300" data-id="element-125">Select Date</h4>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-7 gap-2" data-id="element-126">
          {availableDates.map((date, index) => <div key={index} className={`border rounded-md p-2 text-center cursor-pointer transition-colors ${selectedDate && date.toDateString() === selectedDate.toDateString() ? 'bg-amber-500/20 border-amber-500 text-amber-300' : 'border-blue-800 hover:border-amber-500/50 text-blue-200'}`} onClick={() => handleDateSelect(date)} data-id="element-127">
              <div className="text-xs font-medium" data-id="element-128">
                {date.toLocaleDateString('en-US', {
              weekday: 'short'
            })}
              </div>
              <div className="text-sm" data-id="element-129">{date.getDate()}</div>
              <div className="text-xs" data-id="element-130">
                {date.toLocaleDateString('en-US', {
              month: 'short'
            })}
              </div>
            </div>)}
        </div>
      </div>
      {selectedDate && <div className="mb-8" data-id="element-131">
          <div className="flex items-center gap-2 mb-3" data-id="element-132">
            <ClockIcon className="w-5 h-5 text-amber-400" data-id="element-133" />
            <h4 className="text-lg font-medium text-amber-300" data-id="element-134">Select Time</h4>
          </div>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2" data-id="element-135">
            {timeSlots.map(time => <div key={time} className={`border rounded-md py-2 px-3 text-center cursor-pointer transition-colors ${selectedTime === time ? 'bg-amber-500/20 border-amber-500 text-amber-300' : 'border-blue-800 hover:border-amber-500/50 text-blue-200'}`} onClick={() => handleTimeSelect(time)} data-id="element-136">
                {time}
              </div>)}
          </div>
        </div>}
      <div className="flex justify-between" data-id="element-137">
        <button onClick={prevStep} className="flex items-center gap-1 px-4 py-2 border border-blue-700 rounded-md text-blue-100 hover:bg-blue-800 transition-colors" data-id="element-138">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-139" /> Back
        </button>
        <button onClick={handleContinue} className={`flex items-center gap-1 px-4 py-2 rounded-md transition-colors ${selectedDate && selectedTime ? 'bg-amber-500 text-blue-950 hover:bg-amber-400' : 'bg-blue-800 text-blue-500 cursor-not-allowed'}`} disabled={!selectedDate || !selectedTime} data-id="element-140">
          Continue <ArrowRightIcon className="w-4 h-4" data-id="element-141" />
        </button>
      </div>
    </div>;
};